<template>
    <v-container>
        <div v-if="codeValue && codeValue[0]" style="display:grid;">
            <v-card-title :class="createValue ? 'merge-viewer':'code-viewer'" v-if="codeValue[0]">
                - {{isDiffEditor && getOriginal ? codeValue[0].path : codeValue[0].name}}
            </v-card-title>
<!--            <v-card-text-->
<!--                    id="scroll-target"-->
<!--                    style="max-height: 600px;"-->
<!--                    class="overflow-auto"-->
<!--                    v-if="codeValue[0].name.includes('.png')"-->
<!--            >-->
<!--                <v-img-->
<!--                        :src='cmOption'-->
<!--                        aspect-ratio="1"-->
<!--                        class="grey lighten-2"-->
<!--                        max-width="500"-->
<!--                        max-height="300"-->
<!--                ></v-img>-->
<!--            </v-card-text>-->
<!--            <v-card-text-->
<!--                    id="scroll-target"-->
<!--                    style="max-height: 600px;"-->
<!--                    class="overflow-auto"-->
<!--                    v-else-if="codeValue[0].name.includes('.jpg')"-->
<!--            >-->
<!--                <v-img-->
<!--                        :src='language'-->
<!--                        aspect-ratio="1"-->
<!--                        class="grey lighten-2"-->
<!--                        max-width="500"-->
<!--                        max-height="300"-->
<!--                ></v-img>-->
<!--            </v-card-text>-->
            <v-card-text
                    id="scroll-target"
                    style="max-height: 100%;"
                    class="overflow-auto"
            >

                <MonacoEditor
                        v-if="codeValue.length > 0"
                        ref="meditor"
                        v-model="codeValue[0].code"
                        class="monaco-editor"
                        style="max-height: 100%; height: 800px !important; left: -17px; "
                        :theme="getCodeTheme"
                        :diffEditor="isDiffEditor"
                        :language="language"
                        :original="getOriginal"
                        @change="onCmCodeChange"
                        :key="monacoIds"
                ></MonacoEditor>
            </v-card-text>
<!--            <v-card-text-->
<!--                    v-else-->
<!--                    id="scroll-target"-->
<!--                    style="max-height: 100%;"-->
<!--                    class="overflow-auto"-->

<!--            >-->
<!--                BBBB-->
<!--                <MonacoEditor-->
<!--                        v-if="codeValue.length > 0"-->
<!--                        v-model="codeValue[0].code"-->
<!--                        :theme="getCodeTheme"-->
<!--                        class="monaco-editor"-->
<!--                        style="max-height: 100%; height: 800px !important; left: -17px; "-->
<!--                        :language="language"-->
<!--                        @change="onCmCodeChange"-->
<!--                ></MonacoEditor>-->
<!--                &lt;!&ndash;                <codemirror&ndash;&gt;-->
<!--                &lt;!&ndash;                        v-if="value[0]"&ndash;&gt;-->
<!--                &lt;!&ndash;                        ref="codemirror"&ndash;&gt;-->
<!--                &lt;!&ndash;                        :value="value[0].code"&ndash;&gt;-->
<!--                &lt;!&ndash;                        :options="cmOption"&ndash;&gt;-->
<!--                &lt;!&ndash;                        @ready="onCmReady"&ndash;&gt;-->
<!--                &lt;!&ndash;                        @Focus="onCmFocus"&ndash;&gt;-->
<!--                &lt;!&ndash;                        @input="onCmCodeChange"&ndash;&gt;-->
<!--                &lt;!&ndash;                        height="700"&ndash;&gt;-->
<!--                &lt;!&ndash;                >&ndash;&gt;-->
<!--                &lt;!&ndash;                </codemirror>&ndash;&gt;-->
<!--            </v-card-text>-->
        </div>
    </v-container>
</template>
<script>
    // import 'codemirror/mode/yaml/yaml'
    // import 'codemirror/mode/dockerfile/dockerfile'
    // import 'codemirror/mode/markdown/markdown'
    // import 'codemirror/mode/properties/properties'
    // import 'codemirror/mode/shell/shell'
    // import 'codemirror/mode/xml/xml'
    // import 'codemirror/mode/python/python'
    // import 'codemirror/addon/merge/merge.css'
    // import 'codemirror/addon/merge/merge'
    // import 'codemirror/lib/codemirror.css'
    // import 'codemirror/theme/darcula.css'
    // import 'codemirror/mode/clike/clike'
    // import 'codemirror/lib/codemirror.css'
    // import 'codemirror/theme/darcula.css'
    // import 'codemirror/theme/idea.css'
    // import 'codemirror/addon'
    import DiffMatchPatch from "diff-match-patch";
    import MonacoEditor from 'vue-monaco';

    window.diff_match_patch = DiffMatchPatch
    window.DIFF_DELETE = -1
    window.DIFF_INSERT = 1
    window.DIFF_EQUAL = 0
    export default {
        props: {
            value: Array,
            type: String,
            // diffValue: Array,
            diffValue: {
                type: Array,
                default: function () {
                    return []
                }
            },
            createValue: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        data() {
            return {
                theme: 'vs',
                codeValue: [],
                monacoIds: 0,
            }
        },
        components: {MonacoEditor},
        computed: {
            getOriginal(){
                var me = this
                me.monacoIds = me.monacoIds + 1

                if(me.createValue && me.createValue[0]){
                    return this.createValue[0].code
                }
                this.$emit('type', undefined)
                return ''
            },
            isDiffEditor(){
                this.editor = null
                if( this.type == 'diff'){
                    if(this.createValue && this.createValue.length > 0){
                        return true
                    }
                }
                return false
            },
            getCodeTheme() {
                return this.theme
            },
            // cmOption() {
            //     if (this.value.length > 0) {
            //         if (this.type == "diff") {
            //             if (this.createValue && this.diffValue) {
            //                 var type = {
            //                     value: this.value[0].code,
            //                     // origLeft: this.createValue[0].code,
            //                     orig: this.createValue[0].code,
            //                     connect: 'align',
            //                     mode: 'text/x-java',
            //                     lineNumbers: true,
            //                     collapseIdentical: false,
            //                     highlightDifferences: true
            //                 }
            //             }
            //
            //         } else if (this.value[0].name.includes('.java')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/x-java',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: true,
            //                 scrollbarStyle: null,
            //                 lineWiseCopyCut: true,
            //
            //             }
            //         } else if (this.value[0].name.includes('.yml') || this.value[0].name.includes('.yaml')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/x-yaml',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: true,
            //                 // readOnly: 'nocursor',
            //                 scrollbarStyle: null,
            //                 lineWiseCopyCut: true,
            //             }
            //         } else if (this.value[0].name.includes('.md')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/x-markdown',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //         } else if (this.value[0].name.includes('.properties')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/x-properties',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //         } else if (this.value[0].name.includes('mvnw')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/x-sh',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //         } else if (this.value[0].name.includes('.xml')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'application/xml',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //         } else if (this.value[0].name.includes('Dockerfile')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/x-dockerfile',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //
            //         } else if (this.value[0].name.includes('.json')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'application/json',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //         } else if (this.value[0].name.includes('.py')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/x-python',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //
            //         } else if (this.value[0].name.includes('gitignore')) {
            //             var type = {
            //                 autoCloseBrackets: true,
            //                 tabSize: 4,
            //                 lineNumbers: true,
            //                 line: true,
            //                 mode: 'text/plain',
            //                 theme: 'idea',
            //                 lineWrapping: true,
            //                 matchBrackets: true,
            //                 scroll: true,
            //                 readOnly: 'nocursor'
            //             }
            //         } else if (this.value[0].name.includes('.png') || this.value[0].name.includes('.jpg') || this.value[0].name.includes('.jpeg')) {
            //
            //             var type = `data:image/png;base64,${this.value[0].code}`
            //             // console.log(type)
            //             // console.log(this.value[0])
            //         } else if (this.value[0].name.includes('.jpg') || this.value[0].name.includes('.jpeg')) {
            //             var type = `data:image/jpg;base64,${this.value[0].code}`
            //         }
            //         return type
            //     }
            // },

            language() {
                if (this.codeValue.length > 0) {
                    if (this.codeValue[0].name.includes('.java')) {
                        return 'java'
                    } else if (this.codeValue[0].name.includes('.yml') || this.codeValue[0].name.includes('.yaml')) {
                        return 'yaml'
                    } else if (this.codeValue[0].name.includes('.md')) {
                        return 'markdown'
                    } else if (this.codeValue[0].name.includes('.properties')) {
                        return 'yaml'
                    } else if (this.codeValue[0].name.includes('mvnw')) {
                        return 'shell'
                    } else if (this.codeValue[0].name.includes('.xml')) {
                        return 'xml';
                    } else if (this.codeValue[0].name.includes('Dockerfile')) {
                        return 'dockerfile'
                    } else if (this.codeValue[0].name.includes('.json')) {
                        return 'json'
                    } else if (this.codeValue[0].name.includes('.py')) {
                        return 'python'
                    } else if (this.codeValue[0].name.includes('.go')) {
                        return 'go'
                    } else if (this.codeValue[0].name.includes('.vue')) {
                        return 'javascript'
                    } else if (this.codeValue[0].name.includes('.js')) {
                        return 'javascript'
                    } else if (this.codeValue[0].name.includes('gitignore')) {
                        return 'plaintext'
                    } else if (this.codeValue[0].name.includes('.msaez')) {
                        return 'json'
                    } else if (this.codeValue[0].name.includes('.png') || this.codeValue[0].name.includes('.jpg') || this.codeValue[0].name.includes('.jpeg')) {
                        return `data:image/png;base64,${this.codeValue[0].code}`
                    } else if (this.codeValue[0].name.includes('.jpg') || this.codeValue[0].name.includes('.jpeg')) {
                        return `data:image/jpg;base64,${this.codeValue[0].code}`
                    }else{
                        return 'txt'
                    }
                }else{
                    return 'txt'
                }
            },
            // codeValue(){
            //     return this.value ? this.value : []
            // },
        },
        watch: {
            "value": {
                deep: true,
                handler: function (newVal, oldVal) {
                    var me = this
                    // console.log("==========value==========")
                    // me.$refs.meditor.init
                    me.codeValue = newVal
                }
            },
            //
            // value(newVal,oldVal) {
            //     var me = this
            //     console.log("==========value==========")
            //     if(newVal && newVal.length > 0){
            //         me.codeValue = newVal
            //     }else if( !newVal && oldVal.length > 0){
            //         me.codeValue = oldVal
            //     }
            // },
            diffValue(newVal) {
                // console.log("=========diffvalue=======");
                // console.log(newVal);
            },
            createValue(newVal) {
                // console.log("=========created=======");
                // console.log(newVal);
            }
        },
        methods: {
            changeCodeViewerTheme() {
                if (this.theme == 'vs') {
                    this.theme = 'vs-dark'
                } else {
                    this.theme = 'vs'
                }
            },
            onScroll(e) {
                // this.offsetTop = e.target.scrollTop
            },
            onCmReady(cm) {
                // // console.log('the editor is readied!', cm)

            },
            onCmFocus(cm) {
                // // console.log('the editor is focus!', cm)
            },
            onCmCodeChange(newCode) {
                console.log('this is new code', newCode)
                // sthis.code = newCode
                //
                // console.log("bb")
                // this.codeValue[0].code = newCode
                // var updateValue2 = newCode
                // console.log(this.codeValue[0], updateValue2)
                // this.$emit('update', this.codeValue[0])
            },
        },
        mounted() {
        },
        beforeDestroy() {

        }
    }
</script>
<style>

    .code-viewer {
        position: absolute;
        left: 315px;
        top: -15px;
        margin: 0 0 0 -150px;
    }

    .merge-viewer {
        position: absolute;
        left:310px;  /*left:190px;*/
        top:-44px;  /*top:10px;*/
        font-size: 15px;
        margin: 30px 0 0 -150px;
    }


    @media only screen and (max-width: 900px) {
        /* codePreview 창 줄였을 때 파일명 하단으로 내려가는 부분 */
        /* .code-viewer {
            position: absolute;
            left:165px;
            top:15px;
            margin: 30px 0 0 -150px;
        } */
    }

</style>

